__webpack_require__.p = "https://www.japan.travel/japan-heritage/app/";